<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm12 md2 lg2 class="hidden-sm-and-down">
        <v-navigation-drawer class="fixedSidebar modern-sidebar" clipped width="100%" height="100vh" permanent>
          <!-- Logo area -->
          <div class="sidebar-logo-area">
            <v-img contain width="100%" height="70px" src="../assets/sidelogo.png" fill-height></v-img>
          </div>

          <div class="sidebar-divider"></div>

          <div class="sidebar-scroll">
            <!-- Regular items -->
            <div
              v-for="item in items"
              :key="item.title"
              class="sidebar-item"
              :class="{ 'sidebar-item--active': $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <v-icon class="sidebar-icon">{{ item.icon }}</v-icon>
              <span class="sidebar-label">{{ item.title }}</span>
              <span class="sidebar-active-bar"></span>
            </div>

            <!-- Dynamic Data group -->
            <v-list-group class="sidebar-group pt-0 mt-0" no-action>
              <template v-slot:activator>
                <div class="sidebar-item group-activator">
                  <v-icon class="sidebar-icon">{{ dynamic.icon }}</v-icon>
                  <span class="sidebar-label">{{ dynamic.title }}</span>
                </div>
              </template>
              <div
                v-for="child in dynamic.dynamicItems"
                :key="child.title"
                class="sidebar-item sidebar-item--child"
                :class="{ 'sidebar-item--active': $route.path === child.path }"
                @click="$router.push(child.path)"
              >
                <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
                <span class="sidebar-label">{{ child.title }}</span>
              </div>
            </v-list-group>

            <!-- Case Related group -->
            <v-list-group class="sidebar-group pt-0 mt-0" no-action>
              <template v-slot:activator>
                <div class="sidebar-item group-activator">
                  <v-icon class="sidebar-icon">{{ report.icon }}</v-icon>
                  <span class="sidebar-label">{{ report.title }}</span>
                </div>
              </template>
              <div
                v-for="child in report.reportItems"
                :key="child.title"
                class="sidebar-item sidebar-item--child"
                :class="{ 'sidebar-item--active': $route.path === child.path }"
                @click="$router.push(child.path)"
              >
                <v-icon class="sidebar-icon" style="font-size:14px">mdi-chevron-right</v-icon>
                <span class="sidebar-label">{{ child.title }}</span>
              </div>
            </v-list-group>
          </div>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 sm12 md10 lg10>
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0
            ><v-divider class="pt-0 mt-0"></v-divider
          ></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-3>
            <v-layout
              wrap
              justify-center
              :style="
                $route.name == 'adminDashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              "
            >
              <v-flex xs12>
                <v-card
                  min-height="100vh"
                  :color="
                    $route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  "
                  flat
                >
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeader";

export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        { title: "Public", icon: "mdi-account-group", path: "/Admin/public" },
        {
          title: "Conflict Reports",
          icon: "mdi-source-repository-multiple",
          path: "/Admin/ConflictReports",
        },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/admin/analytics",
        },
        {
          title: "My Reports",
          icon: "mdi-file-chart",
          path: "/Admin/myReport",
        },
      ],
      dynamic: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        dynamicItems: [
          {
            title: "Scenerios",
            path: "/Admin/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/Admin/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/Admin/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/Admin/dynamicData/animalStatus",
          },
          {
            title: "Mitigations",
            path: "/Admin/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/Admin/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/Admin/dynamicData/gender",
          },
          {
            title: "Breach Types",
            path: "/Admin/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/Admin/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/Admin/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/Admin/dynamicData/cropType",
          },
        ],
      },
      report: {
        title: "Case Related",
        icon: "mdi-folder",
        visible: false,
        reportItems: [
          {
            title: "Report Case",
            path: "/Admin/reportCase",
          },
          {
            title: "Resolve Case",
            path: "/Admin/resolveCase",
          },
          {
            title: "Release Case",
            path: "/Admin/releaseCase",
          },
        ],
      },
      right: null,
    };
  },
  methods: {},
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* ── Sidebar shell ─────────────────────────────── */
.modern-sidebar {
  background: linear-gradient(180deg, #183824 0%, #254b31 100%) !important;
  box-shadow: 4px 0 24px rgba(24, 56, 36, 0.15) !important;
  border-right: none !important;
  font-family: 'Inter', sans-serif;
  display: flex !important;
  flex-direction: column !important;
}

/* ── Logo area (fixed header, matches navbar height) */
.sidebar-logo-area {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* ── Divider ───────────────────────────────────── */
.sidebar-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  margin: 4px 12px 8px;
}

/* ── Scrollable nav area ───────────────────────── */
.sidebar-scroll {
  overflow-y: auto;
  height: calc(100vh - 120px); /* adjusted height because no section toggle exists */
  flex: 1;
  padding: 4px 8px 16px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

/* ── Nav items ─────────────────────────────────── */
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  margin: 2px 0;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  transition: background 0.22s ease;
}

.sidebar-item:hover::before {
  background: rgba(255, 255, 255, 0.07);
}

.sidebar-item:hover {
  transform: translateX(3px);
}

.sidebar-item:hover .sidebar-icon {
  color: #7eb95f !important;
  text-shadow: 0 0 10px rgba(126, 185, 95, 0.6) !important;
}

.sidebar-item:hover .sidebar-label {
  color: #ffffff;
}

/* Active state */
.sidebar-item--active {
  background: #7eb95f !important;
  border: 1px solid rgba(126, 185, 95, 0.3) !important;
  box-shadow: 0 4px 12px rgba(126, 185, 95, 0.25) !important;
}

.sidebar-item--active .sidebar-icon {
  color: #102411 !important;
}

.sidebar-item--active .sidebar-label {
  color: #102411 !important;
  font-weight: 700 !important;
}

.sidebar-item--active .sidebar-active-bar {
  display: block !important;
  position: absolute !important;
  right: 0 !important;
  top: 25% !important;
  width: 3px !important;
  height: 50% !important;
  background: #102411 !important;
  border-radius: 4px 0 0 4px !important;
  box-shadow: 0 0 8px rgba(16, 36, 17, 0.7) !important;
}

.sidebar-active-bar {
  display: none;
}

/* Icon & label ────────────────────────────────── */
.sidebar-icon {
  color: rgba(255, 255, 255, 0.45) !important;
  font-size: 18px !important;
  flex-shrink: 0;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

.sidebar-label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s ease;
}

/* Child items (nested) ────────────────────────── */
.sidebar-item--child {
  padding-left: 22px;
}

.sidebar-item--child .sidebar-label {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.5);
}

/* Vuetify list-group override inside sidebar ──── */
.sidebar-group .v-list-group__header {
  padding: 0 !important;
  min-height: unset !important;
  background: transparent !important;
}

.sidebar-group .v-list-group__items {
  background: transparent !important;
}

.group-activator {
  width: 100%;
}
</style>